<template>
  <div :class="$style.content">
    <CanvasForm
      :value="canvas1"
      :image="canvas1Image"
      @input="setCanvas1"
      @image="setCanvas1Image"
    />
  </div>
</template>

<script>
import CanvasForm from '@/components/canvas/Form'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { CanvasForm },
  computed: {
    ...mapState(['canvas1', 'canvas1Image'])
  },
  methods: {
    ...mapMutations(['setCanvas1', 'setCanvas1Image']),
  },
  mounted() {
    this.$emit('title', 'Front Picture')
    this.$emit('prevLink', 'Main')
    this.$emit('nextLink', 'MobileCanvas2')
  }
}
</script>

<style lang="scss" module>
.content {
  height: 100%;
  margin: 0 -50px;
}
</style>